import { useNavigate } from "react-router-dom";
import Button from 'devextreme-react/button';
import ContextMenu, { Position } from 'devextreme-react/context-menu';
import { useMemo } from "react";
import { useGetCompany } from "../../../../api/company";
import { useAuth } from "../../../../contexts/auth";

export default function CreateEstimateButton() {

	const navigate = useNavigate();

	const { user } = useAuth();
	const company = useGetCompany(user?.companyId);
	const eeRetailers = company.data?.assignedRetailers.filter(x => x.eeShowInPortal && !!x.easyEstimatorUrl);

	const menuItems = useMemo(() => {

		if (!eeRetailers || eeRetailers.length === 0) {
			return [{ text: 'EE Pro Tool', icon: 'Inscyth-EEPro', estimatorUrl: '/cfi/easy-estimator/new', openInNewWindow: false }];
		}

		if (eeRetailers.length === 1) {

			const retailer = eeRetailers[0];
			return [
				{ text: 'Easy Estimator 2.0', icon: 'Inscyth-Easy-Estimator', estimatorUrl: retailer.easyEstimatorUrl, openInNewWindow: true },
				{ text: 'EE Pro Tool', icon: 'Inscyth-EEPro', estimatorUrl: '/cfi/easy-estimator/new', openInNewWindow: false }
			];
		}
		else {
			return [
				{
					text: 'Easy Estimator 2.0',
					icon: 'Inscyth-Easy-Estimator',
					items: eeRetailers.map(x => {
						return {
							text: x.companyName,
							estimatorUrl: x.easyEstimatorUrl,
							openInNewWindow: true
						};
					})
				},
				{ text: 'EE Pro Tool', icon: 'Inscyth-EEPro', estimatorUrl: '/cfi/easy-estimator/new', openInNewWindow: false }
			];
		}
	}, [eeRetailers]);

	return (
		<>
			<Button id="create-estimate-button">
				<i className="dx-icon dx-icon-Inscyth-Easy-Estimator"></i>
				Create Estimate
				<i className={'dx-icon dx-icon-chevrondown'}></i>
			</Button>
			<ContextMenu
				width={165}
				items={menuItems}
				target="#create-estimate-button"
				showEvent="click"
				onItemClick={(e) => {
					const data = e.itemData as any;

					if (!!data.estimatorUrl) {
						if (data.openInNewWindow) {
							window.open(data.estimatorUrl);
						}
						else {
							navigate(data.estimatorUrl);
						}
					}
				}}
			>
				<Position my='left top' at='left bottom'>
				</Position>
			</ContextMenu>
		</>
	);
}